<mat-dialog-content class="upload-photos-box text-center">
  <mat-icon class="text-[60px]! w-[60px]! h-[40px]! mb-[35px]">cloud_upload</mat-icon>

  <h6 class="text-left">
    Uploading {{ data.isQuote ? 'Quote' : data.isInvoice ? 'Invoice' : data.isPhotos ? 'Photos' : 'Documents' }}
  </h6>

  @if (!wrongFormatMessage() && !maxSizeExceedMessage()) {
    <mat-progress-bar class="progress-bar mt-10 rounded-[25px]" mode="determinate" [value]="progress()" />
    <div class="photo-counter text-charcoal-60 my-10 body-2">uploading {{ uploadedFiles() }}/{{ totalFiles() }}</div>
  }

  @if (wrongFormatMessage() || maxSizeExceedMessage()) {
    <div class="error-message-box">
      <div class="warn-box">
        <mat-icon matPrefix>report_problem</mat-icon>
        <div class="warn-box-max-size-exceed-msg">{{ maxSizeExceedMessage() }}</div>
        <div>{{ wrongFormatMessage() }}</div>
      </div>
    </div>
  }

  <mat-divider />

  <button
    (click)="!wrongFormatMessage() && !maxSizeExceedMessage() && stopUpload()"
    class="mt-10 text-red w-[200px]"
    mat-button
    mat-dialog-close>
    {{ wrongFormatMessage() || maxSizeExceedMessage() ? 'OK' : 'STOP UPLOAD' }}
  </button>
</mat-dialog-content>
